import { Link } from "react-router-dom";

const cols = [
  {
    title: "Results",
    links: [
      { to: "/", label: "Today's Result" },
      { to: "/common-number", label: "Common Number" },
      { to: "/previous-result", label: "Previous Result" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about-us", label: "About Us" },
      { to: "/contact-us", label: "Contact Us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/terms-and-conditions", label: "Terms & Conditions" },
      { to: "/disclaimer", label: "Disclaimer" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          <div className="col-span-2 sm:col-span-1">
            <span className="font-oswald text-xl font-bold text-white">
              Night Teer <span className="text-red-500">Result</span>
            </span>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">
              Fast daily Night Teer FR & SR results, common numbers and previous results.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">{c.title}</h3>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
                      data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-slate-800 text-xs text-slate-500 leading-relaxed">
          <p className="mb-2">
            Disclaimer: Night Teer Result Today is an informational website. Common numbers and related number
            information are for informational and entertainment purposes only. We do not guarantee any predictions or
            winning numbers. Users are responsible for following applicable local laws.
          </p>
          <p>© {new Date().getFullYear()} Night Teer Result Today. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
